/* ==========================================================================
   Brake Bias Calculator
   Self-contained. Loaded only on this calculator's page.
   No shared dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc-bbc]');
  if (!root) return;

  /* Brake torque at an axle is proportional to piston area times effective
     radius. Pad friction and line pressure are common to both ends, so they
     cancel out of the ratio and are not needed here. */
  function area(dia, count) { return Math.PI * Math.pow(dia / 2, 2) * count; }

  /* ====================================================================
     compute(input) -> result

     PURE. No DOM, no network, no globals. All calculator logic lives here
     so it can be reasoned about and tested in isolation.
     ==================================================================== */
  function compute(input) {
    var need = ['fPiston','fCount','fRotor','rPiston','rCount','rRotor'];
    for (var i = 0; i < need.length; i++) {
      if (!isFinite(input[need[i]]) || input[need[i]] <= 0) {
        return { ok: false, errors: ['Fill in all six caliper and rotor figures.'] };
      }
    }
    var pad = isFinite(input.padOffset) && input.padOffset > 0 ? input.padOffset : 50;

    var fArea = area(input.fPiston, Math.round(input.fCount));
    var rArea = area(input.rPiston, Math.round(input.rCount));
    var fRad = (input.fRotor / 2) - (pad / 2);
    var rRad = (input.rRotor / 2) - (pad / 2);

    if (fRad <= 0 || rRad <= 0) {
      return { ok: false, errors: ['Pad height is too large for those rotors. Check the numbers.'] };
    }

    var fTorque = fArea * fRad;
    var rTorque = rArea * rRad;
    var frontPct = (fTorque / (fTorque + rTorque)) * 100;

    var status;
    if (frontPct < 60) {
      status = { key: 'now', label: num(frontPct, 1) + '% front',
                 note: 'Very rear biased. The rear will lock before the front, which makes the car want to spin under hard braking.' };
    } else if (frontPct < 65) {
      status = { key: 'soon', label: num(frontPct, 1) + '% front',
                 note: 'Rear biased for a road car. Fine on a purpose built race car with a proportioning valve, risky otherwise.' };
    } else if (frontPct <= 80) {
      status = { key: 'good', label: num(frontPct, 1) + '% front',
                 note: 'Inside the normal road car range of roughly 65 to 80% front.' };
    } else {
      status = { key: 'soon', label: num(frontPct, 1) + '% front',
                 note: 'Strongly front biased. Safe, but the rear brakes are contributing little and the fronts will run hot.' };
    }

    return {
      ok: true, errors: [], warnings: [], status: status,
      figures: [
        { label: 'Front bias', value: num(frontPct, 1) + '%',
          sub: 'Rear takes the remaining ' + num(100 - frontPct, 1) + '%.' },
        { label: 'Front to rear torque', value: num(fTorque / rTorque, 2) + ' : 1',
          sub: 'How much more braking torque the front axle makes at the same line pressure.' }
      ],
      rows: [
        { head: 'Front axle' },
        { label: 'Piston area', value: num(fArea, 0) + ' mm2' },
        { label: 'Effective radius', value: num(fRad, 1) + ' mm' },
        { label: 'Relative torque', value: num(fTorque / 1000, 0) },
        { head: 'Rear axle' },
        { label: 'Piston area', value: num(rArea, 0) + ' mm2' },
        { label: 'Effective radius', value: num(rRad, 1) + ' mm' },
        { label: 'Relative torque', value: num(rTorque / 1000, 0) },
        { head: 'Balance' },
        { label: 'Front', value: num(frontPct, 1) + '%' },
        { label: 'Rear', value: num(100 - frontPct, 1) + '%' }
      ]
    };
  }

  /* ====================================================================
     Formatting
     ==================================================================== */
  function comma(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n, dp) {
    if (!isFinite(n)) return '-';
    var v = Number(n).toFixed(dp == null ? 2 : dp);
    if (dp !== 0 && v.indexOf('.') > -1) v = v.replace(/\.?0+$/, '');
    var parts = v.split('.');
    return comma(parts[0]) + (parts[1] ? '.' + parts[1] : '');
  }

  function signed(n, dp) {
    if (!isFinite(n)) return '-';
    return (n > 0 ? '+' : '') + num(n, dp);
  }

  /* ====================================================================
     DOM wiring
     ==================================================================== */
  var FIELDS = [
      {
          "name": "fPiston",
          "key": "fp",
          "type": "number"
      },
      {
          "name": "fCount",
          "key": "fn",
          "type": "number"
      },
      {
          "name": "fRotor",
          "key": "fr",
          "type": "number"
      },
      {
          "name": "rPiston",
          "key": "rp",
          "type": "number"
      },
      {
          "name": "rCount",
          "key": "rn",
          "type": "number"
      },
      {
          "name": "rRotor",
          "key": "rr",
          "type": "number"
      },
      {
          "name": "padOffset",
          "key": "po",
          "type": "number"
      }
  ];

  var els = {
    error:    root.querySelector('[data-r-error]'),
    status:   root.querySelector('[data-r-status]'),
    statusLbl:root.querySelector('[data-r-status-label]'),
    statusVal:root.querySelector('[data-r-status-value]'),
    statusNote:root.querySelector('[data-r-status-note]'),
    figures:  root.querySelector('[data-r-figures]'),
    rows:     root.querySelector('[data-r-rows]'),
    warnings: root.querySelector('[data-r-warnings]')
  };

  var STATUS_CLASSES = ['is-good','is-monitor','is-soon','is-now','is-critical'];

  function field(name) { return root.querySelector('[data-f="' + name + '"]'); }

  function readInput() {
    var o = {};
    FIELDS.forEach(function (f) {
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') o[f.name] = el.checked;
      else if (f.type === 'number') o[f.name] = parseFloat(el.value);
      else o[f.name] = el.value;
    });
    return o;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function renderFigures(figs) {
    els.figures.innerHTML = (figs || []).map(function (f) {
      return '<div class="pc-bbc__figure">'
        + '<div class="pc-bbc__figure-label">' + esc(f.label) + '</div>'
        + '<div class="pc-bbc__figure-value' + (f.muted ? ' is-muted' : '') + '">'
        + esc(f.value) + '</div>'
        + (f.sub ? '<div class="pc-bbc__figure-sub">' + esc(f.sub) + '</div>' : '')
        + '</div>';
    }).join('');
  }

  function renderRows(rows) {
    if (!els.rows) return;
    els.rows.innerHTML = (rows || []).map(function (r) {
      if (r.head) {
        return '<div class="pc-bbc__row pc-bbc__rows-head">' + esc(r.head) + '</div>';
      }
      return '<div class="pc-bbc__row">'
        + '<span class="pc-bbc__row-label">' + esc(r.label) + '</span>'
        + '<span class="pc-bbc__row-value">' + esc(r.value) + '</span>'
        + '</div>';
    }).join('');
  }

  function clearResult(message) {
    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      els.statusVal.textContent  = 'Waiting for your numbers';
      els.statusNote.textContent = message || '';
    }
    els.figures.innerHTML = '';
    if (els.rows) els.rows.innerHTML = '';
    if (els.warnings) els.warnings.style.display = 'none';
  }

  function render() {
    var input  = readInput();
    var result = compute(input);

    if (!result.ok) {
      els.error.textContent = result.errors[0];
      els.error.classList.add('is-shown');
      clearResult(result.errors[0]);
      return;
    }
    els.error.classList.remove('is-shown');

    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      if (result.status) {
        els.status.classList.add('is-' + result.status.key);
        els.statusVal.textContent  = result.status.label;
        els.statusNote.textContent = result.status.note || '';
      } else {
        els.statusVal.textContent  = '';
        els.statusNote.textContent = '';
      }
    }

    renderFigures(result.figures);
    renderRows(result.rows);

    if (els.warnings) {
      if (result.warnings && result.warnings.length) {
        els.warnings.textContent = result.warnings[0];
        els.warnings.style.display = '';
      } else {
        els.warnings.style.display = 'none';
      }
    }

    writePermalink(input);
  }

  /* ====================================================================
     Shareable result permalinks
     ==================================================================== */
  function writePermalink(input) {
    if (!window.history || !window.history.replaceState) return;
    var q = FIELDS.map(function (f) {
      var v = input[f.name];
      if (f.type === 'checkbox') return v ? f.key + '=1' : '';
      if (v == null || v !== v || v === '') return '';
      return f.key + '=' + encodeURIComponent(v);
    }).filter(Boolean).join('&');
    try {
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }

  function applyPermalink() {
    if (!window.URLSearchParams) return;
    var p = new URLSearchParams(window.location.search);
    var any = false;
    FIELDS.forEach(function (f) {
      if (!p.has(f.key)) return;
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') el.checked = p.get(f.key) === '1';
      else el.value = p.get(f.key);
      any = true;
    });
    return any;
  }

  /* ====================================================================
     Init
     ==================================================================== */
  ['input', 'change'].forEach(function (evt) {
    root.addEventListener(evt, function (e) {
      if (e.target.closest('[data-r-form]')) render();
    });
  });

  applyPermalink();
  render();

  /* Exposed for testing and debugging only. */
  window.PC_BBC = { compute: compute };
})();
